import isSsr from '~/shared/utils/isSsr';
import ActionButton from './ActionButton';
import Leaderboard from './Leaderboard';
import PrizePool from './PrizePool';
import BannerBox from './styles/BannerBox';
import GameBannerContainer from './styles/GameBannerContainer';
import TournamentInfo from './TournamentInfo';
import type { TournamentFragment } from '../../../graphql/TournamentFragment.generated';
import { useTournamentUpdatedSubscription } from '../../../graphql/TournamentUpdatedSubscription.generated';
import TournamentTimer from '../../../shared/TournamentCard/PrizeCountdown/TournamentTimer';

type Props = {
  tournament: TournamentFragment;
};

const GameBannerView: FC<Props> = ({ tournament }) => {
  useTournamentUpdatedSubscription({
    variables: {
      input: {
        tournamentId: tournament.id,
      },
    },
    skip: isSsr(),
  });

  return (
    <GameBannerContainer>
      <TournamentInfo tournament={tournament} />
      <BannerBox className="justify-center gap-1">
        <TournamentTimer tournament={tournament} isGameBanner />
      </BannerBox>
      <BannerBox className="justify-center gap-1">
        <PrizePool prize={tournament?.prizeText} />
      </BannerBox>
      <BannerBox>
        <Leaderboard tournament={tournament} />
      </BannerBox>
      <ActionButton tournament={tournament} />
    </GameBannerContainer>
  );
};

export default GameBannerView;
